<template>
  <div class="convert-info">
    <span>1 {{ props.rate.from }} = {{ props.rate.rate }} {{ props.rate.to }}</span>
    <Timer :endDate="modifiedEndDate"/>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';

import Timer from "@kano/components/Shared/Timer"
import { ExchangeRate } from "@kano/types";

const props = defineProps<{
  rate: ExchangeRate,
  endDate: string
}>();

const modifiedEndDate = computed(() => {
  const endDateTime = new Date(props.endDate).getTime();
  const now = Date.now();
  const diffInSeconds = Math.floor((endDateTime - now) / 1000);

  if (diffInSeconds <= 60) {
    return new Date(endDateTime);
  }

  return new Date(now + 60 * 1000);
});
</script>
<style lang="scss" scoped>
.convert-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--color-base-8);
  color: var(--color-base-64);
  font-size: 14px;
  line-height: 20px;

  &__warning {
    color: var(--color-red);
  }
}
</style>